import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import moment from 'moment';
import { Map, Marker, InfoWindow, Feature, DataLayer } from 'google-react-maps';
import { InfoWidget, FieldList } from '../../';
import { getIconForClient } from 'utils';
import { FileUploader, ConfirmationPrompt, IncidentReportGenerator } from '../../';
import { IncidentFormNew } from './';

class IncidentPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      changing_photo: false,
      editing_incident: false,
      incident: {},
    }
  }

  componentWillReceiveProps() {
    this.setState({ editing_incident: false, changing_photo: false });
  }

  render() {
    const { storm, damage_level, material_type, adjuster, description, front_image, _id } = this.props.incident;
    const client = this.props.client;

    // if (!storm) {
    //   return <h3 className="text-center">Please Select a Incident</h3>
    // }

    let damageLevelColor;

    switch(damage_level) {
      case 'Light':
        damageLevelColor = 'green'
        break;
      case 'Moderate':
        damageLevelColor = 'orange'
        break;
      case 'Severe':
        damageLevelColor = 'red';
        break;
      default:
        damageLevelColor = '';
        break;
    }
    let warning = null;
    // const longitude = client.address.feature ? client.address.feature.geometry.coordinates[0];
    // const latitude = client.address.feature ? client.address.feature.geometry.coordinates[1];
    if(!client.address.geocoded) {
      warning =  <div className="alert alert-danger">
        <h3>Warning</h3>
        <p>This client is not geocoded. Your address may be invalid. Make sure it has all the necessary fields to geocode.</p>
      </div>
    }
    return (
      <div className="incident-container" ref="incidentContainer">
        {warning ? <div className="col-xs-12">{warning}</div> : null}
        <div className="col-xs-12 col-md-4 col-lg-4 col-xl-4">
          <InfoWidget title='Damage Level' text={damage_level} icon='fa fa-bolt' iconBgColor={damageLevelColor} />
        </div>
        <div className="col-xs-12 col-md-4 col-lg-4 col-xl-4">
          <InfoWidget title='Material Type' text={material_type} icon='fa fa-info' />
        </div>
        <div className="col-xs-12 col-md-4 col-lg-4 col-xl-4">
          <InfoWidget title='Adjuster' text={adjuster} icon='fa fa-user-circle-o' />
        </div>
        <div className="col-xs-8">
            <div>
            <h3 className="text-muted"><i className="fa fa-cloud"></i> Storm Details</h3>
            {this.props.incident.storm && typeof this.props.incident.storm === 'object' ? (
              <FieldList
                fields={[
                  {_id : 1, name : 'storm.properties.max_wind_speed', label : 'Max Wind Speed', flex : 3},
                  {_id : 2, name : 'storm.properties.max_hail_size', label : 'Max Hail Size', flex : 3},
                  {_id : 3, name : 'storm.properties.house_count', label : 'Max House Count', flex : 3},
                  {_id : 4, name : 'storm.properties.isolated', label : 'Isolated Hail', flex : 3},
                  {_id : 5, name : 'storm.properties.title', label : 'Map Name', flex : 6},
                  {_id : 6, name : 'storm.properties.storm_date', label : 'Storm Date', flex : 6},

                ]}
                entity={this.props.incident}
                readOnly={true}
              />
            ) : <p className="text-muted text-center">No Storm Selected.</p>}

            </div>
        </div>
        <div className="col-xs-12 col-md-4">
          <h3 className="text-muted"><i className="fa fa-home"></i> Front Image
            <a style={{display: `${!front_image ? 'none' : ''}`}} onClick={() => { this.setState({ changing_photo: !this.state.changing_photo }) }} className={`btn btn-sm ${this.state.changing_photo ? 'btn-danger' : 'btn-primary'} pull-right`}>
              {(() => this.state.changing_photo
                          ? <span><i className="fa fa-close"></i> &nbsp; Cancel</span>
                          : <span><i className="fa fa-photo"></i> &nbsp; Change Photo</span>
              )()}
            </a>
          </h3>
          {(() => {
            if (!front_image || this.state.changing_photo) {
              return <FileUploader
                onSuccess={() => {
                  this.props.fetchIncident(_id);
                  this.setState({ changing_photo: false });
                }}
                endpoint={`/upload/clientIncident/${_id}/front_image`}
              />
            }
            else {
              return <img src={front_image.url} className="rounded img-responsive" alt="John Doe"/>;
            }
          })()}
        </div>
        <div className="col-xs-12">
          <h3 className="text-muted"><i className="fa fa-building"></i> Incident Details
            <a onClick={() => this.setState({ editing_incident: !this.state.editing_incident })} className={`btn btn-primary ${this.state.editing_incident ? 'btn-danger' : 'btn-primary'} pull-right`}>
              {(() => this.state.editing_incident
                          ? <span><i className="fa fa-close"></i> &nbsp; Cancel</span>
                          : <span><i className="fa fa-cogs"></i> &nbsp; Modify</span>
              )()}
            </a>
          </h3>
          <IncidentFormNew
            editing={this.state.editing_incident}
            entity={this.props.incident}
            onSubmit={(incident) => this.props.sendSocketEmit(incident, 'client-incident-edit')}
          />
        </div>
        {/* <IncidentReportGenerator incident={this.props.incident} /> */}
      </div>
    )
  }
}

IncidentPreview.contextTypes = {
  incident : PropTypes.object,
}

const mapStateToProps = ({ client_incidents, client }) => ({
  incident: client_incidents.incidents.find((incident) => incident._id === client_incidents.selected_incident) || {},
  client: client
});

export default connect(mapStateToProps, Actions)(IncidentPreview);



// WEBPACK FOOTER //
// ./src/browser/components/client/incidents/incident-preview.js